import React, { FC } from 'react'
import BookmarkOfProductButton from 'src/common/razzle-platform-bookmarkofproduct/BookmarkOfProduct/BookmarkOfProductButton'


interface BookmarkOfProductProps {
    productId: string
    bookmarkButton?: FC<{ onClick: () => void, isBookmarked: boolean, inProgress: boolean }>
}


export const BookmarkOfProduct: FC<BookmarkOfProductProps> = (props) => {
    return(
        <BookmarkOfProductButton {...props} />
    )
}
